module.exports = __webpack_public_path__ + "static/media/OT2@2x.3e79e214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OT/OT2@2x.png
// module id = 711
// module chunks = 0